import { Component, Input, Inject, HostListener } from '@angular/core';
import { encapsulation } from '../../encapsulation';
import { UBXAccordionComponent } from '../accordion.component';
import { UBXAccordionRowComponent } from '../row/accordion-row.component';

@Component({
    selector: 'ubx-accordion-head',
    templateUrl: './accordion-head.component.html',
    host: { class: 'ubx-accordion-head pd:x25 pd:y15 pointer' },
    encapsulation
})
export class UBXAccordionHeadComponent {
    @Input() open: boolean;

    constructor(
        @Inject(UBXAccordionComponent) private accordion: UBXAccordionComponent,
        @Inject(UBXAccordionRowComponent) private row: UBXAccordionRowComponent,
    ) { }

    @HostListener('click') onClick() {
        if (this.row.disable) {
            return;
        }
        if (this.accordion.multi) {
            this.open = !this.row.open ? true : false;
        } else {
            this.open = !this.row.open;
            this.accordion.closeAllRows();
        }
        this.row.toggleRow(this.open);
    }
}
